import React from "react";
import { Link } from "react-router-dom";
import "./Home.css";
import backgroundImage from "../../img/Background.jpg";
import Services from "../services/Services";
import Projects from "../projects/Projects";
import Contact from "../contact/Contact";
import About from "../About/About";

function Home() {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero"  style={{ backgroundImage: `url(${backgroundImage})` }}>
        <div className="hero-content">
          <h1>Building the Future, Restoring the Past</h1>
          <p>
            Aarcon Construction delivers quality infrastructure and modern
            designs with trust and innovation.
          </p>
          
          <Link to="/projects" className="btn-primary">
            View Our Projects
          </Link>
        </div>
      </section>
      <section>
          <Projects/>
          <Services/>
          <About/>
          <Contact/>
      </section>

      {/* Services Section
      <section className="services">
        <h2>Our Core Services</h2>
        <div className="services-grid">
          <div className="service-card">
            <h3>🏗️ Civil Construction</h3>
            <p>
              From residential to commercial projects, we deliver durable and
              efficient infrastructure.
            </p>
          </div>
          <div className="service-card">
            <h3>🛠️ Renovation</h3>
            <p>
              Modern designs with top-quality finishing to renovate your dream
              spaces.
            </p>
          </div>
          <div className="service-card">
            <h3>📐 Architectural Planning</h3>
            <p>
              Smart architectural designs that blend innovation with
              functionality.
            </p>
          </div>
        </div>
      </section> */}

      {/* Call to Action */}
      <section className="cta">
        <h2>Ready to Start Your Project?</h2>
        <Link to="/contact" className="btn-secondary">
          Get in Touch
        </Link>
      </section>
    </div>
  );
}

export default Home;
